import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { ClientSideLineTrackingListDto } from "../../../core/models/project-workflow/clientSideLineTrackingListDto";
import { TrackingHistoryListDto } from "../../../core/models/project-workflow/trackingHistoryListDto";
import { LoaderService } from "../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { getShippingMethodDisplay } from "../../../core/utilities/carrier-shipping-method";

@Component({
  selector: "jni-tracking-list",
  templateUrl: "./tracking-list.component.html",
  styleUrls: ["./tracking-list.component.scss"],
  // fixes/14757: imports: [TableModule, CommonModule, SelectModule, FormsModule, ButtonModule],
  imports: [TableModule, CommonModule, SelectModule, FormsModule, ButtonModule],
})
// fixes/14757: export class TrackingListComponent {
export class TrackingListComponent {
  @Input() workflowTrackingList = [] as ClientSideLineTrackingListDto[];
  @Input() showDetailLinks = false;
  @Input() isDisableLink = false;
  @Input() showEdit = false;
  disableOptionValue = 0;

  @Output() deleteRowEvent = new EventEmitter<ClientSideLineTrackingListDto>();
  @Output() deleteTrackingRecordEvent =
    new EventEmitter<ClientSideLineTrackingListDto>();
  @Output() showTrackingDetailEvent =
    new EventEmitter<ClientSideLineTrackingListDto>();
  @Output() showTrackingHistoryEvent =
    new EventEmitter<ClientSideLineTrackingListDto>();
  @Output() rowEditSaveEvent =
    new EventEmitter<ClientSideLineTrackingListDto>();
  @Output() refreshGrid = new EventEmitter();

  trackingHistoryModalOpen = false;
  trackingDetailsModalOpen = false;
  trackingHistoryList = [] as TrackingHistoryListDto[];
  historyTrackingNumber = "";

  getShippingMethodDisplay = getShippingMethodDisplay;

  @ViewChild("dtTrackingList") table!: Table;
  editingRows = new Set<number>();

  startEdit(id: number) {
    this.editingRows.add(id);
  }
  stopEdit(id: number) {
    this.editingRows.delete(id);
  }

  statusList = [
    {
      id: 0,
      name: "Pending",
    },
    {
      id: 1,
      name: "Shipped",
    },
    {
      id: 2,
      name: "In-Transit",
    },
    // {
    //   id: 3,
    //   name: 'Exception',
    // },
    {
      id: 4,
      name: "Delivered",
    },
  ];

  constructor(private _loaderService: LoaderService) {}
  // fixes/14757: constructor(private _loaderService: LoaderService) {}

  deleteRowPageList(event: ClientSideLineTrackingListDto) {
    this.deleteRowEvent.emit(event);
  }

  deleteTrackingRecord(event: ClientSideLineTrackingListDto) {
    this.deleteTrackingRecordEvent.emit(event);
  }

  trackingDetails(event: ClientSideLineTrackingListDto) {
    this.showTrackingDetailEvent.emit(event);
  }

  trackingHistory(event: ClientSideLineTrackingListDto) {
    this.showTrackingHistoryEvent.emit(event);
  }

  editLine(trackingNumber: string, status: number) {
    this.disableOptionValue = status;
  }

  onStatusChange(lineTracking: ClientSideLineTrackingListDto) {
    this._loaderService.setLoaderState(true);
    this.stopEdit(lineTracking.id);
    this.rowEditSaveEvent.emit(lineTracking);
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }
  /** @deprecated Use onStatusChange instead. Kept for compatibility. */
  onRowEditSave(lineTracking: ClientSideLineTrackingListDto) {
    this.onStatusChange(lineTracking);
  }

  getStatus(status: number) {
    if (status) {
      return this.statusList.find(x => x.id == status)?.name ?? "";
    }
    return "Pending";
  }

  refreshGridEvent() {
    this.refreshGrid.emit();
  }
}
